import {AppActions, useAppContext} from "../../context/AppContext";
import React, {useEffect, useState} from "react";
import XsBrowserBar from "./XsBrowserBar";
import CrossSectionWindow from "../outputs/ui/CrossSection/CrossSectionWindow";
import DeckRoadwayWindow from "../outputs/ui/DeckRoadway/DeckRoadwayWindow";
import CulvertWindow from "../outputs/ui/Culvert/CulvertWindow";
import BridgeWindow from "../outputs/ui/Bridge/BridgeWindow";

// UI tab: browse ANY river station (cross sections AND structures) and see the right
// window for the selected RS. The browser is injected into the shared page toolbar
// (like the Plot/Map tabs). Each xs_plots item carries the full rs shape
// (base_ui_data / cmp_ui_data for a cross section; deck_dist_data / base_bridges /
// base_culverts + cmp for a structure), so the windows' existing base/compare
// behaviour is unchanged.
export default function UITab() {
    const {dispatchProject, selectedHistoryId} = useAppContext()
    const [item, setItem] = useState(null)

    useEffect(() => {
        dispatchProject({
            type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
            data: {toolbar: (<XsBrowserBar persistKey={`${selectedHistoryId}:uitab`} onSelect={setItem}/>)}
        })
        return () => {
            dispatchProject({type: AppActions.SET_MESSAGE_TOOLBAR_ITEM, data: null})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedHistoryId]);

    if (!item) return <div style={{marginTop: 16}}/>

    return (
        <div style={{marginTop: 16}}>
            {item.type === 'structure' ? (
                <>
                    <DeckRoadwayWindow riverStation={item} />
                    {(item?.base_culverts?.length > 0 || item?.cmp_culverts?.length > 0) && (
                        <><br/><CulvertWindow riverStation={item} /></>
                    )}
                    {(item?.base_bridges?.length > 0 || item?.cmp_bridges?.length > 0) && (
                        <><br/><BridgeWindow riverStation={item} /></>
                    )}
                </>
            ) : (
                <CrossSectionWindow riverStation={item} />
            )}
        </div>
    )
}
